import { isCookieError as isJigsawCookieError } from '../jigsaw-helpers';
import { isCookieError as isBridgeCookieError } from '../bridge-helpers';
import { GET_SESSION } from '../redux-bridge/bridge-methods';
import { GET_USER_INFO } from '../redux-jigsaw/jigsaw-methods';
import { getQueryParamsForReload } from 'app/api/redux-watson/watson-config-selectors';
import { appendOrUpdateParams } from 'app/utils/route';

function handleAccessError(apiCall) {
  return function(dispatch) {
    if (apiCall !== GET_SESSION && apiCall !== GET_USER_INFO) {
      dispatch(afterLogOut());
    }
  };
}

export function afterLogOut() {
  return function(dispatch, getState) {
    const params = getQueryParamsForReload(getState());
    window.location.assign(appendOrUpdateParams('/', params));
  };
}

export function tryRedirectJigsawFailure(err, apiCall) {
  return function(dispatch) {
    if (err.errorCode === 401 || isJigsawCookieError(err)) {
      dispatch(handleAccessError(apiCall));
    }
  };
}

export function tryRedirectBridgeFailure(err, apiCall) {
  return function(dispatch) {
    if (err.status === 401 || isBridgeCookieError(err)) {
      dispatch(handleAccessError(apiCall));
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/api/redux-route/route-actions.js